// IE 2026 10 11 / ODOO-345618 (заказ Игоря: согласование под ключ) — FE3: картина процесса согласования (вкладка «Approval» отчёта и виджет approval-overview страницы page-approval).
// Чистая логика без Vue и стора: ответ бэка approval_overview (REPORT-OV1 п. 1) → модель экрана (прогресс версии, карточки сроков и «моё», шаги-шевроны со статусами,
// людьми и кнопками массовых действий, «кто кого ждёт», последние события); кнопка → действие approval_bulk (REPORT-OV1 п. 2) с окном комментария (store.confirmInput).
// Выключатели: fe.ux.approvalTab (вкладка отчёта), fe.ux.approvalOverviewPage (компонент вместо HTML страницы), fe.ux.approvalBulk (кнопки действий) — по умолчанию вкл.
// Тесты — tests/unit/approvalOverview.test.mjs
import { t } from '@/i18n'
import { approvalStatusCode, approvalStatusTitle, approvalCategories, approvalTime, approvalTimeTip, approvalActionTitle, approvalUserLink } from '@/utils/approval'

const isObj = (x) => !!x && typeof x === 'object' && !Array.isArray(x)
const str = (x) => (x === undefined || x === null) ? '' : String(x)
const num = (x) => { const n = Number(x); return isFinite(n) ? n : 0 }

// счётчики шага / версии в порядке полосы прогресса: сделано → в работе → ждёт
export const OV_KEYS = ['approved', 'approved_changed', 'skipped', 'frozen', 'review', 'returned', 'draft', 'waiting']
const CSS = { approved: 'cell-background-green', approved_changed: 'cell-background-orange', skipped: 'cell-background-grey', frozen: 'cell-background-blue',
    review: 'cell-background-yellow', returned: 'cell-background-red', draft: 'cell-background-grey', waiting: 'ap-ov-waiting' }
export function ovStatusTitle(key) { return approvalStatusTitle(approvalStatusCode(key)) || str(key) }
export function ovStatusCss(key) { return CSS[key] || 'cell-background-grey' }
// IE 2026 11 03 / ODOO-350449 (s143): плашка статуса события ленты — ключ, известный фронту (draft / review / approved …), — его перевод и цвет, как раньше;
// иной (статусы уровней v2: approved_1 …) — подпись и cssClass записи STATUS-plan от бэка (status_*_title / status_*_css, на языке пользователя).
// Сверка s143 (dev02): approved_1 рисовался серой плашкой с сырым ключом. Нет ни того, ни другого — ключ как есть, серый
export function ovEvStatusTitle(key, beTitle) { return approvalStatusTitle(approvalStatusCode(key)) || str(beTitle).trim() || str(key) }   // IE 2026 11 03 / ODOO-350449 (s143)
export function ovEvStatusCss(key, beCss) { const k = str(key).replace(/-/g, '_'); return CSS[k] || str(beCss).trim() || 'cell-background-grey' }   // IE 2026 11 03 / ODOO-350449 (s143)
export function ovPct(n, total) { const t0 = num(total); return t0 > 0 ? Math.round(num(n) * 1000 / t0) / 10 : 0 }
export function ovInt(n) { const v = Math.round(num(n)); return v.toLocaleString('uk-UA').replace(/[\u00a0\u202f]/g, ' ') }

// ответ бэка → блоки «сегмент · версия»
export function ovBlocks(data) {
    const out = []
    for (const s of (isObj(data) && Array.isArray(data.segments) ? data.segments : [])) {
        if (!isObj(s)) continue
        const seg = isObj(s.segment) ? s.segment : { id: str(s.segment), title: str(s.segment) }
        for (const b of Array.isArray(s.versions) ? s.versions : []) {
            if (!isObj(b)) continue
            const v = isObj(b.version) ? b.version : { id: str(b.version), title: str(b.version) }
            out.push({ key: str(seg.id) + '|' + str(v.id), segment: { id: str(seg.id), title: str(seg.title || seg.id) }, version: { id: str(v.id), title: str(v.title || v.id) }, block: b })
        }
    }
    return out
}

// полоса прогресса и легенда по счётчикам (totals или шаг)
export function ovBar(c) {
    const total = num(isObj(c) ? c.total : 0)
    const parts = [], legend = []
    for (const k of OV_KEYS) {
        const n = num(c?.[k])
        if (!n && !['approved', 'review', 'draft', 'waiting', 'returned'].includes(k)) continue
        const item = { key: k, n, nText: ovInt(n), pct: ovPct(n, total), css: ovStatusCss(k), title: ovStatusTitle(k) }
        legend.push(item)
        if (n > 0) parts.push(item)
    }
    return { total, parts, legend }
}

// держатели роли шага (OV3): approver_holders / preparer_holders бэка → {users [{id, name, primary, me}], more, total}; старый бэк — пусто
// IE 2026 10 11 / ODOO-345618 (заказ Игоря: согласование под ключ) — FE5: человек без записи USER (user.no_user) — без id: имя текстом, e-mail в tip, key — для v-for
export function ovPerson(u) {
    const l = approvalUserLink(u)
    return { id: l.noUser ? '' : str(u?.id), name: l.text, tip: l.tooltip, noUser: l.noUser, key: str(u?.id) || ('nu:' + str(u?.email) + '|' + l.text) }
}
export function ovHolders(h) {
    const users = (isObj(h) && Array.isArray(h.users) ? h.users : []).filter(isObj).map(u => ({ ...ovPerson(u.user), primary: u.primary === true, me: false, system: u.user?.system === true }))
    return { users, more: num(h?.more), total: num(h?.total) || users.length }
}

// «кто ждёт» по шагу: ответственные (primary_count) — по убыванию, «ще N»
export function ovStepPeople(waiting, order) {
    const key = str(order)
    return (Array.isArray(waiting) ? waiting : []).filter(w => isObj(w) && isObj(w.steps) && num(w.steps[key]) > 0)
        .map(w => ({ ...ovPerson(w.user), me: w.me === true, n: num(w.steps[key]), primary: num(w.primary_count) }))
        .sort((a, b) => b.primary - a.primary || b.n - a.n)
}

// кнопки шага: что можно сделать массово по текущему отбору; неактивная — с причиной. opts: {canAdmin, bulk (выключатель / права), readonly}
export function ovStepButtons(step, opts = {}) {
    const my = isObj(step?.my) ? step.my : {}
    const admin = !!opts.canAdmin, off = opts.bulk === false
    const draft = num(step?.draft) + num(step?.returned), review = num(step?.review), waiting = num(step?.waiting)
    const approved = num(step?.approved) + num(step?.approved_changed)
    const out = []
    const add = (code, label, n, enabled, reason, extra = {}) => out.push({ code, label, n, nText: ovInt(n), enabled: !off && enabled, reason: off ? t('Bulk actions are switched off') : (enabled ? '' : reason), ...extra })
    // Submit
    const myDrafts = num(my.my_drafts) + num(my.my_returned)
    if (myDrafts > 0) add('submit', t('Submit my drafts'), myDrafts, true, '', { scope: { my: true }, primary: true })
    else if (admin && draft > 0) add('submit', t('Submit drafts on behalf'), draft, true, '', { onBehalf: true })
    else add('submit', t('Submit my drafts'), 0, false, draft > 0 ? t('you have no drafts at this step') : t('no drafts in the selection'))
    // Approve
    const forMe = num(my.waiting_for_me)
    if (forMe > 0) add('approve', t('Approve what waits for me'), forMe, true, '', { scope: { my: true }, primary: true })
    else if (admin && review > 0) add('approve', t('Approve on behalf'), review, true, '', { onBehalf: true })
    else add('approve', t('Approve what waits for me'), 0, false, review > 0 ? t('in review, but it is not your move') : (waiting > 0 ? t('the step has not reached approval yet') : t('nothing in review')))
    // Return
    if (forMe > 0) add('return', t('Return…'), forMe, true, '', { scope: { my: true } })
    else if (admin && review > 0) add('return', t('Return on behalf…'), review, true, '', { onBehalf: true })
    else add('return', t('Return…'), 0, false, review > 0 ? t('no units where it is your move') : t('nothing in review'))
    // Recall (готовящий забирает отправленное): права проверяет бэк по каждой единице
    if (review > 0) add('recall', admin ? t('Recall on behalf…') : t('Recall…'), review, true, '', admin ? { onBehalf: true } : {})
    else add('recall', t('Recall…'), 0, false, t('nothing in review'))
    // Reopen — только администратор, с причиной
    if (admin && approved > 0) add('reopen', t('Reopen…'), approved, true, '', { onBehalf: true })
    else add('reopen', t('Reopen…'), 0, false, approved > 0 ? t('administrators only (with a comment)') : t('nothing approved in the selection'))
    return out
}

// модель блока версии. opts: {canAdmin, bulk, me, filter}
export function ovVersionModel(entry, data, opts = {}) {
    const b = isObj(entry?.block) ? entry.block : {}
    const totals = isObj(b.totals) ? b.totals : {}
    const waiting = Array.isArray(b.waiting_by_user) ? b.waiting_by_user : []
    const myTot = isObj(totals.my) ? totals.my : {}
    const steps = (Array.isArray(b.steps) ? b.steps : []).filter(s => isObj(s) && s.order != null).map(s => {
        const people = ovStepPeople(waiting, s.order)
        const my = isObj(s.my) ? s.my : {}
        const mine = num(my.waiting_for_me) + num(my.my_drafts) + num(my.my_returned) > 0
        const holders = ovHolders(s.approver_holders)
        const byRole = !people[0] && holders.users.length > 0   // OV3: единицы шага ещё не у людей (waiting) — показываем держателей роли утверждающего
        const chips = OV_KEYS.filter(k => num(s[k]) > 0).map(k => ({ key: k, n: num(s[k]), nText: ovInt(s[k]), css: ovStatusCss(k), title: ovStatusTitle(k) }))
        return {
            order: num(s.order), title: str(s.title || s.order), mode: str(s.mode), optional: str(s.mode) === 'optional',
            preparerRole: str(s.preparer_role), approverRole: str(s.approver_role),
            preparerRoleTitle: str(s.preparer_role_title || s.preparer_role), approverRoleTitle: str(s.approver_role_title || s.approver_role),   // OV3: названия записей ACCESS-rights; старый бэк — код роли
            pct: num(s.progress?.pct) || ovPct(s.progress?.done, s.progress?.total), total: num(s.total), chips,
            responsible: byRole ? holders.users[0] : (people[0] || null), more: byRole ? holders.users.slice(1) : people.slice(1), moreExtra: byRole ? holders.more : 0, byRole, mine,
            due: { nearest: str(s.nearest_due), nearestText: approvalTime(s.nearest_due), overdue: num(s.overdue), soon: num(s.due_soon) },
            waitsLower: num(s.waiting) > 0 && num(s.review) + num(s.draft) === 0,
            buttons: ovStepButtons(s, opts),
        }
    })
    const final = isObj(totals.final) ? totals.final : null
    return {
        key: entry?.key || '', segment: entry?.segment || {}, version: entry?.version || {},
        unitVersion: str(b.unit_version || entry?.version?.id), cycleAt: str(b.cycle_at), error: str(b.error),
        progress: { pct: num(totals.progress?.pct), done: num(totals.progress?.done), total: num(totals.progress?.total || totals.total) },
        bar: ovBar(totals), stepsCount: steps.length,
        cards: { overdue: num(totals.overdue), soon: num(totals.due_soon), nearest: str(totals.nearest_due), nearestText: approvalTime(totals.nearest_due),
            forMe: num(myTot.waiting_for_me), myDrafts: num(myTot.my_drafts) + num(myTot.my_returned) },
        final: final ? { step: num(final.step), approved: num(final.approved), total: num(final.total) } : null,
        steps,
        waiting: waiting.filter(isObj).map(w => ({ ...ovPerson(w.user), system: w.user?.system === true, me: w.me === true,
            primary: num(w.primary_count), also: num(w.also_count), overdue: num(w.overdue),
            steps: Object.keys(isObj(w.steps) ? w.steps : {}).sort((x, y) => num(x) - num(y)).map(k => ({ order: num(k), n: num(w.steps[k]), title: str(steps.find(s => s.order === num(k))?.title || k) })) })),
        waitingMore: num(b.waiting_users_more),
        recent: (Array.isArray(b.recent) ? b.recent : []).filter(isObj).map(e => ({ id: str(e.id), at: str(e.at), atText: approvalTime(e.at), atTip: approvalTimeTip(e.at),
            who: ovPerson(e.user).name, whoTip: ovPerson(e.user).tip, whoId: e.user?.system ? '' : ovPerson(e.user).id, action: str(e.action), actionTitle: t(str(e.action_title || e.action)),
            step: num(e.step), from: str(e.status_from), to: str(e.status_to), fromTitle: ovEvStatusTitle(e.status_from, e.status_from_title), toTitle: ovEvStatusTitle(e.status_to, e.status_to_title),   // IE 2026 11 03 / ODOO-350449 (s143)
            fromCss: ovEvStatusCss(e.status_from, e.status_from_css), toCss: ovEvStatusCss(e.status_to, e.status_to_css),   // IE 2026 11 03 / ODOO-350449 (s143): + подпись и цвет записи STATUS-plan от бэка
            changed: !!e.status_from && e.status_from !== e.status_to, comment: str(e.comment), unit: str(e.unit), unitTitle: str(e.dims_text || e.unit_title), onBehalf: e.on_behalf === true })),
        job: isObj(b.bulk_job) ? b.bulk_job : null,
    }
}

// карточка «сегмент · версия» страницы
export function ovCard(entry) {
    const m = ovVersionModel(entry, null, { bulk: false })
    return { key: m.key, segment: m.segment, version: m.version, pct: m.progress.pct, bar: m.bar, total: m.progress.total, drafts: num(entry?.block?.totals?.draft),
        overdue: m.cards.overdue, nearestText: m.cards.nearestText, forMe: m.cards.forMe, error: m.error }
}

// единицы строк отчёта: _DLRow.approval.units {шаг: id} | [id], unit — без повторов, до limit
export function ovUnitsOfRows(items, limit = 5000) {
    const out = new Set()
    for (const di of Array.isArray(items) ? items : []) {
        const ap = di?._DLRow?.approval
        if (!isObj(ap)) continue
        const u = ap.units
        if (Array.isArray(u)) u.forEach(x => x && out.add(str(x)))
        else if (isObj(u)) Object.values(u).forEach(x => x && out.add(str(x)))
        if (ap.unit) out.add(str(ap.unit))
        if (out.size >= limit) break
    }
    return [...out].slice(0, limit)
}

// отбор → scope запроса: all | mine | rows (единицы строк отчёта) | selected (выделенные строки). null — отбор по строкам пуст: ни сводки, ни действий
// (пустой scope.units бэк понимает как «без отбора» — массовое действие ушло бы на всю версию)
export function ovScope(filter, units) {
    if (filter === 'mine') return { my: true }
    if (filter === 'overdue') return { overdue: true }   // OV3: только просроченные единицы (scope.overdue бэка)
    if (filter === 'rows' || filter === 'selected') return Array.isArray(units) && units.length ? { units: units.slice() } : null
    return {}
}

// действие approval_bulk для store.executeStoreMethod (окно комментария — confirm_input; категории возврата — doc._approval). ctx: {segment, version, scope, da, step}
export function ovBulkAction(btn, ctx = {}) {
    const code = str(btn?.code), behalf = !!btn?.onBehalf
    const scope = { ...(isObj(ctx.scope) ? ctx.scope : {}), ...(isObj(btn?.scope) ? btn.scope : {}), step: ctx.step }
    if (ctx.segment) scope.segment = ctx.segment
    if (ctx.version) scope.version = ctx.version
    const params = { action: code, scope, ...(ctx.segment ? { segment: ctx.segment } : {}), ...(ctx.version ? { version: ctx.version } : {}), ...(behalf ? { on_behalf: true } : {}) }
    const need = behalf || ['return', 'reopen', 'skip'].includes(code)
    const head = t('{action}: up to {n} unit(s) of the step «{step}» in the selection.', { action: str(btn?.label).replace(/…$/, ''), n: ovInt(btn?.n), step: str(ctx.stepTitle || ctx.step) })
    const tail = ' ' + t('Units where the action is not possible for you are skipped with the reason; more than 300 units run in the background.')
        + (behalf ? ' ' + t('You act on behalf of the role of the step; the comment stays in the history.') : '')
    const ci = { field: 'comment', label: code === 'reopen' || code === 'skip' ? t('Reason') : t('Comment'), value: '', required: need }
    if (code === 'return') {
        const cats = approvalCategories(ctx.da)
        if (cats.length) Object.assign(ci, { options: cats.map(c => ({ field: 'category', value: c.id, label: c.title, default: false })), exclusive: true, optionsRequired: false })
    }
    return { name: 'button-approval-bulk-' + code, attr_type: 'AttrButton', title: str(btn?.label).replace(/…$/, '') + ' · ' + str(ctx.stepTitle || ctx.step),
        command: 'executeWidgetMethod', method: 'approval_bulk', approval_code: 'bulk', params, record_sendToBackend_exclude: ['_doc'],
        confirm: head + tail, confirm_input: ci }
}

// ход фонового действия: {running, text, pct}
export function ovJob(job) {
    if (!isObj(job)) return null
    const total = num(job.total), done = num(job.done)
    const running = str(job.state) === 'running' && !job.stale
    const text = t('{action}: {done} / {total}', { action: (job.action && approvalActionTitle(job.action)) || t('Bulk action'), done: ovInt(done), total: ovInt(total) })
        + (num(job.skipped_count) ? ' · ' + t('skipped {n}', { n: ovInt(job.skipped_count) }) : '')
        + (running ? '' : (str(job.state) === 'error' ? ' · ' + t('error') : (job.stale ? ' · ' + t('stopped') : ' · ' + t('done'))))
    return { running, text, pct: ovPct(done, total), state: str(job.state) }
}

// итог синхронного действия (answer.approval_bulk) — строка для плашки компонента
export function ovBulkResult(res) {
    if (!isObj(res)) return ''
    if (res.queued) return t('Queued: {n} unit(s); running in the background', { n: ovInt(res.total) })
    if (res.running) return t('Another bulk action is still running')
    return t('Done {done} of {total}', { done: ovInt(res.done), total: ovInt(res.total) }) + (num(res.skipped_count) ? ' · ' + t('skipped {n}', { n: ovInt(res.skipped_count) }) : '')
        + ((Array.isArray(res.errors) && res.errors.length) ? ' · ' + str(res.errors[0]) : '')
}

// IE 2026 10 13 / ODOO-5800: заголовок прогресса. Не «все единицы версии» — «Selection progress» + «<N rows> · <M units> · <K steps>» (N — строки отчёта хотя бы с одной единицей,
// M — единиц на шаг = total / steps), подсказка — название отбора; «all» — прежнее «Version progress · total units (K steps)». Флаг fe.approval.scopedHeader (дефолт ВКЛ)
export const SCOPED_HEADER_FLAG = 'fe.approval.scopedHeader'
export function ovScopedHeaderOn(setting) {
    try { return typeof setting === 'function' ? setting(SCOPED_HEADER_FLAG, true) !== false : true } catch (e) { return true }
}
// число строк отчёта, давших хотя бы один id единицы
export function ovRowsWithUnits(items) {
    let n = 0
    for (const di of Array.isArray(items) ? items : []) {
        const ap = di?._DLRow?.approval
        if (!isObj(ap)) continue
        const u = ap.units
        const has = (Array.isArray(u) ? u.some(Boolean) : isObj(u) ? Object.values(u).some(Boolean) : false) || !!ap.unit
        if (has) n++
    }
    return n
}
// {title, summary, tip}: filter — id отбора, filterTitle — его подпись (чип), total — единиц×шагов (bar.total), steps, rows — число строк (null — неизвестно)
export function ovProgressHeader({ filter = 'all', filterTitle = '', total = 0, steps = 0, rows = null, flagOn = true } = {}) {
    const k = num(steps), tot = num(total)
    if (!flagOn || filter === 'all') return { title: t('Version progress'), summary: ovInt(tot) + ' ' + t('units') + ' (' + k + ' ' + t('steps') + ')', tip: '' }
    const m = k > 0 ? Math.round(tot / k) : tot
    const parts = []
    if ((filter === 'rows' || filter === 'selected') && rows !== null && rows !== undefined) parts.push(t('{n} rows', { n: num(rows) }))
    parts.push(t('{n} units', { n: m }), t('{n} steps', { n: k }))
    return { title: t('Selection progress'), summary: parts.join(' · '), tip: str(filterTitle) }
}
